<template>
	<inertia-head title="Home" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0 mb-3">
					<h1 class="fw-bold text-white mb-2">
						Welcome to the {{ $page.props.app.name }}!
					</h1>
				</div>
			</div>
		</div>
	</div>

	<div class="content">

		<div class="col-12 mb-7">
        	<h1 class="text-center mb-2">Welcome Video</h1>
            <div class="embed-responsive">
                <iframe class="shadow-sm embed-responsive-item" src="https://player.vimeo.com/video/1155024873" allowfullscreen></iframe>
            </div>
        </div>

	</div>
</template>

<script>

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);
	
import { watch, onMounted, ref, reactive } from 'vue'
import AuthLayout from '../../Layouts/AuthLayout'
import { createToaster } from '@meforma/vue-toaster'
import { useForm, usePage } from '@inertiajs/inertia-vue3'

export default {
	props:{
		flash 					: Object,
	},
	layout: AuthLayout,
	setup(props) {

		const toast = createToaster();
		
		onMounted(() => {
			const pageContainer = document.getElementById('page-container')
			if (pageContainer.classList.contains('sidebar-o-xs'))
			{
				pageContainer.classList.remove('sidebar-o-xs')
			}
			
		})

		return{}

	},
}
</script>
